import { null as zNull } from "zod/v4";

export const disconnectGlobalEIntegration = {
  name: "disconnectGlobalEIntegration" as const,
  input: zNull(),
  output: zNull(),
};
